import {
  // 日期筛选器
  RANGE_TIME as RANGE_TIME_SELECT_FILTER,
  // 单榜单筛选器
  SINGLE_SOURCE_SELECT as SINGLE_SOURCE_SELECT_FILTER,
  STORERANK_SEGEMENT,
  REGION,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

export const getInitialFormValueStoreRankDetail = (isOperate: boolean, filterExtend: any, defaultFormValue: any) => {
  // 没有操作过筛选器，不继承
  if (!isOperate) return defaultFormValue || {};

  /** 各个筛选器的继承值 **/
  const rangeTimeFilterExtend = filterExtend?.[RANGE_TIME_SELECT_FILTER];
  const regionFilterExtend = filterExtend?.[REGION];
  const singleSourceFilterExtend = filterExtend?.[SINGLE_SOURCE_SELECT_FILTER];
  const storerankSegmentFilterExtend = filterExtend?.[STORERANK_SEGEMENT];
  /** 各个筛选器的继承值 **/

  /** 各个筛选器的默认值 **/
  const rangeTimeDefault = defaultFormValue?.[RANGE_TIME_SELECT_FILTER];
  const regionDefault = defaultFormValue?.[REGION];
  const singleSourceDefault = defaultFormValue?.[SINGLE_SOURCE_SELECT_FILTER];
  const storerankSegmentDefault = defaultFormValue?.[STORERANK_SEGEMENT];
  /** 各个筛选器的默认值 **/


  let rangeValue = rangeTimeDefault?.value;
  // 这里只有日粒度，只需要继承日粒度时间
  if (rangeTimeFilterExtend?.time_type === 'day') {
    rangeValue = rangeTimeFilterExtend?.filterValue || rangeTimeDefault?.value;
  }

  return {
    // storerank-segment切换筛选器
    [STORERANK_SEGEMENT]: {
      value: storerankSegmentFilterExtend?.value || storerankSegmentDefault?.value,
    },
    // 日期筛选器
    [RANGE_TIME_SELECT_FILTER]: {
      type: rangeTimeDefault?.type,
      value: rangeValue,
    },
    // 国家筛选器
    [REGION]: {
      type: regionDefault?.type,
      markets: regionFilterExtend?.markets?.length ? regionFilterExtend?.markets : regionDefault?.markets,
    },
    // 单榜单筛选器
    [SINGLE_SOURCE_SELECT_FILTER]: {
      value: singleSourceFilterExtend?.value || singleSourceDefault?.value,
    },
  };
};
